import { Icon } from '@iconify/react'

import { IconPicker } from '@/components/icon-picker/IconPicker.jsx'

import { useRoleGuard } from '@/hooks/useRoleGuard.jsx'

import { UserRoles } from '@/consts/index.js'

// Sidebar row icon (reports / dashboards) that editors can click to change the glyph and
// its color (colored glyph, no background). Until someone picks one (icon.customized),
// the row keeps its default look, so existing items don't change on their own.
export const NavItemIcon = ({ icon, defaultIcon, defaultClassName, onChange }) => {

    const canEdit = useRoleGuard(UserRoles.EDITOR, 'space')

    const isCustom = !!icon?.customized && !!icon?.value
    const value = isCustom
        ? { type: 'icon', value: icon.value, color: icon.color || 'text-muted-foreground' }
        : { type: 'icon', value: defaultIcon, color: defaultClassName }

    if (!canEdit) {
        return <Icon icon={value.value} className={`h-4 w-4 shrink-0 ${value.color}`} />
    }

    const handleChange = (next) => {
        if (!canEdit) {
            return
        }
        onChange({ type: 'icon', value: next.value, color: next.color, customized: true })
    }

    return (
        // Keep the click inside the picker: the row itself navigates on click.
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
            <IconPicker value={value} onChange={handleChange} variant="plain" />
        </div>
    )
}
